import { ChebyshevCoefficients } from '@ootk/src/interpolator/ChebyshevCoefficients';
import { Seconds } from '@ootk/src/main';

export const makemakeChebyshevCoeffs: ChebyshevCoefficients[] = [
  new ChebyshevCoefficients(
    631152000 as Seconds,
    788940000 as Seconds,
    new Float64Array([
      -12352904853.567245, -131171616.45329612, 3138290.4090717635, 11442.756878948212, -9204.512475172678, -10.554246552785237, -665.97756255467732, -406.20262982050576,
      -231.47174402872722, -615.37141939798994, 698.76314401626587, -64.080907090504965,
    ]),
    new Float64Array([
      1821647760.6039782, -271860215.18605042, -455474.28569032351, 72817.334839526811, 652.41954743067424, -700.43903799057011, 468.6965395371119, -527.44058467547097,
      170.95857478777566, -683.40898711681371, -82.502850516637167, -170.41550451914469,
    ]),
    new Float64Array([
      8695128528.4456806, -70599807.151863441, -2057438.1302952447, 31677.008076635997, 567.06161801020301, -341.34592402776082, 201.23383684158324, -183.60435031255085,
      66.694972229003909, -306.2715712706248, 6.0495865027109783, -116.16590852737427,
    ])
  ),
  new ChebyshevCoefficients(
    788940000 as Seconds,
    946728000 as Seconds,
    new Float64Array([
      -12829144783.330175, -107337009.83947003, 2698898.6428827601, -48210.390716457368, 6561.5175418535864, 2093.5420888264975, -775.06486488978067, 53.827310434977214,
      -342.30036872227987, -63.511311690012612, 500.72759752273561, 120.43786109288533,
    ]),
    new Float64Array([
      731218841.15924144, -272945768.72136915, 10198.534062194823, -23842.464086584248, -9647.6479965845738, 593.12192153533294, 85.667236145337426, -646.72214327653251,
      11.867375282446543, -851.93802655935281, 34.232645682493846, -147.56762968301774,
    ]),
    new Float64Array([
      8381763183.4778786, -85888054.246698633, -1834803.3584673246, -7734.0494283199305, -4225.7919719219208, 104.93630639712016, 14.261845525105795, -343.94659790992739,
      0.66971386273701983, -384.86814554532367, 72.535742282867432, 31.741911967595417,
    ])
  ),
  new ChebyshevCoefficients(
    946728000 as Seconds,
    1104516000 as Seconds,
    new Float64Array([
      -13214855724.14234, -85182768.236748636, 3061506.5102558136, 60233.730261739096, -7122.7963848749796, -882.44367310206098, -368.49562905629477, -44.713407961527508,
      -306.43049446741742, 254.6123292605082, 659.10936911900842, -101.33959290186564,
    ]),
    new Float64Array([
      -362761227.58397502, -274239716.44344944, -180213.33344742507, 48226.364720957477, 8026.8174946710469, -850.85082483838005, -38.355782473584014, -433.73934058894713,
      -270.09910120069981, -651.30191214432318, -15.997648166120053, 136.65220492084822,
    ]),
    new Float64Array([
      8007941768.6671991, -101098384.6922662, -1906199.6209480604, 21017.772592624027, 3631.586178414027, -332.54713017145792, -53.160731061299643, -231.42095858256022,
      25.903455114364622, -333.04555808703105, 128.5540369351705, 67.118726809819535,
    ])
  ),
  new ChebyshevCoefficients(
    1104516000 as Seconds,
    1262304000 as Seconds,
    new Float64Array([
      -13504996805.535469, -59907743.238943383, 3042596.0090218862, -57199.410943571726, -5061.4009716669716, 838.28266471227005, -662.94265079498291, -37.653927421569826,
      -264.66772098541259, 42.363146209716795, 813.35362431208296, 9.1456854184468579,
    ]),
    new Float64Array([
      -1457827418.5268593, -272657619.58874536, 552730.18573817215, 36261.526909772554, -8210.5336076239746, -812.53396202921863, 66.988842213153845, -540.11509289542835,
      143.7804142932097, -820.20109821359313, -196.10686630805333, 38.441759322086966,
    ]),
    new Float64Array([
      7575207360.1924858, -114974797.21072349, -1566441.4840332507, 19329.096250152586, -3333.3481018225352, -317.49404702186587, -65.959746408462522, -258.5995542526245,
      30.948007631301881, -412.65587617556253, -19.672955385843913, 6.5582412083943682,
    ])
  ),
  new ChebyshevCoefficients(
    1262304000 as Seconds,
    1420092000 as Seconds,
    new Float64Array([
      -13699169663.917011, -37392036.32006222, 2819943.8044341407, 59252.551870218915, 5259.776806163788, -2131.2094411532084, -732.61985289255779, -53.683515739440914,
      -349.98974939982094, -172.93449678421021, 679.43895060221348, 235.17929172515869,
    ]),
    new Float64Array([
      -2540012894.9642334, -268653841.55159628, 336664.87482432125, -12949.119791487852, 11345.602450621129, 711.49231190284092, -305.66413106520969, -388.10656027396521,
      -103.49830454190572, -578.42860662937164, -38.081502592563631, 76.254950869083402,
    ]),
    new Float64Array([
      7090344125.6057138, -127518947.43141368, -1622120.7845829327, -3985.7954865455627, 4676.7264081160229, 399.47750196456911, -158.32387135823566, -223.44585479100544,
      13.397029113769531, -296.69872500101724, 33.508687067031858, 50.763012647628784,
    ])
  ),
  new ChebyshevCoefficients(
    1420092000 as Seconds,
    1577880000 as Seconds,
    new Float64Array([
      -13799938897.01815, -12667887.327359771, 3188172.3628975232, -26632.402278963724, -8283.1803910255439, 203.85779517491659, -789.47740847269688, -257.79231615066527,
      -163.81473306020101, -47.036801846822101, 704.74832744598393, -73.962711111704508,
    ]),
    new Float64Array([
      -3606850847.9481382, -264268473.34958908, 898304.24401324592, 65350.510724663734, -2740.7343205134075, -750.68680814107256, -40.689030806223549, -621.02032126585641,
      18.00126485824585, -854.76129214763637, -70.377541176478061, 185.35784123738605,
    ]),
    new Float64Array([
      6555486033.3697309, -139673467.58615965, -1352324.5737714448, 32125.154530763626, -1020.2357831637064, -163.55642824172975, 49.167717774709068, -169.95227505366006,
      -8.4776867389678952, -416.2626704851786, -111.56214882532755, -73.843697277704877,
    ])
  ),
  new ChebyshevCoefficients(
    1577880000 as Seconds,
    1735668000 as Seconds,
    new Float64Array([
      -13803320027.316347, 10451761.670492936, 2604830.1931075412, -10571.399815400442, 13257.792125670116, 499.6350363731384, -1109.7412366549174, -14.850546232859294,
      -302.41504446665448, 265.41277008056642, 621.33828789393101, -89.891864077250162,
    ]),
    new Float64Array([
      -4647032230.6262617, -255719607.11241123, 1013912.8606355429, -50443.694799121222, -1675.6520141204198, 2340.8828656435012, 165.04732818603514, -531.40382926464076,
      83.611385758717859, -736.03926222324367, 197.0571900288264, 63.564119386672971,
    ]),
    new Float64Array([
      5976598474.3392534, -149677219.59801179, -1244879.5356261095, -17588.789214166005, -992.34160458246868, 996.2858747323354, 142.11642419497173, -225.35341129302978,
      -133.10945749282837, -300.8409996350606, -122.03783864974976, -1.4777780691782634,
    ])
  ),
  new ChebyshevCoefficients(
    1735668000 as Seconds,
    1893456000 as Seconds,
    new Float64Array([
      -13717220412.115177, 33053029.644847963, 3094198.9091039659, 22449.430461502074, -9140.5695853869111, 19.627276833852132, -951.47163238525388, -164.90094509124756,
      -181.96230818430581, -277.97786019643149, 779.65732237497969, 34.608032162984209,
    ]),
    new Float64Array([
      -5655241777.4782133, -248343776.08711308, 1063924.858979543, 63486.950822575884, 2662.1104571342466, -866.73251681327815, 38.627308797836307, -659.82896537780766,
      -1.6385993798573812, -941.14487058321629, -148.22377823193867, 20.804167191187542,
    ]),
    new Float64Array([
      5357546849.6931925, -159801172.94495213, -1186626.7354522864, 30910.184160757064, 1386.6997893333435, -437.46358850797014, 98.30014545122782, -308.28729546864827,
      -28.001668945948282, -408.53880680402119, -180.07995886802672, 58.468865887324014,
    ])
  ),
  new ChebyshevCoefficients(
    1893456000 as Seconds,
    2051244000 as Seconds,
    new Float64Array([
      -13536623956.755735, 56908859.759559408, 2708011.047891553, -62072.004715887706, 2123.9509707450866, 1873.5704366048176, -865.65731283823652, -270.46316095987953,
      -417.66623471577964, -231.35392058690388, 1001.4598523775736, 244.24494349161785,
    ]),
    new Float64Array([
      -6627286834.9949656, -237215235.17801893, 1592135.4053375721, -7986.8267509937286, -10223.497101895015, 15.846457592646281, 390.02355715433754, -653.84417424201968,
      89.755332183837893, -981.72679610252374, -2.2654676596323648, -126.08800021807353,
    ]),
    new Float64Array([
      4701564125.2070885, -167938833.1095489, -897314.85625406902, 2782.9826628208161, -4381.3146400928499, -116.78961734771728, 198.34939991633098, -321.12896874745684,
      -10.753645737965902, -452.82413976987203, -49.168374379475914, 15.44270388285319,
    ])
  ),
  new ChebyshevCoefficients(
    2051244000 as Seconds,
    2209032000 as Seconds,
    new Float64Array([
      -13266907890.322777, 78075797.677154288, 2841282.6088402746, 61262.42802645365, -4789.1958586692808, -1499.551034228007, -627.57006918589275, 0.095186360677083331,
      -382.43163480758665, 61.085273329416907, 534.15202722549441, -1.1596305847167969,
    ]),
    new Float64Array([
      -7552972050.7529144, -225904288.43842766, 1314861.3748058954, 30051.61963391304, 10237.333649301529, -859.94863125483198, -369.67330012321474, -397.94208696683245,
      -198.38546568552653, -812.17319016456599, -104.73088501294454, 50.087519566218056,
    ]),
    new Float64Array([
      4014854625.4258251, -175489515.53789151, -961623.06823115342, 16392.266047048568, 4500.8764652570089, -507.1434578259786, -197.35197402636209, -332.72786444822947,
      -41.509355886777243, -372.09931141535441, 18.394423516591388, 211.50910886128744,
    ])
  ),
  new ChebyshevCoefficients(
    2209032000 as Seconds,
    2366820000 as Seconds,
    new Float64Array([
      -12907194628.899942, 101806717.77120256, 2871853.310801792, -57498.699478212991, -6763.2423392931623, 613.53626511891684, -730.49230594635014, 131.07058111826578,
      -234.15858847300211, 170.18982543945313, 970.92290471394858, -77.44203968048096,
    ]),
    new Float64Array([
      -8431381748.6715059, -212693334.01968002, 2010622.2095802783, 45751.408600473405, -6602.3237029870352, -728.52799701690674, 33.739256223042808, -712.03258482615149,
      -121.9124502023061, -978.75762915611267, -86.448969062169397, 65.551944255828857,
    ]),
    new Float64Array([
      3299642919.49646, -181803709.4475151, -600795.19483417668, 26596.770765765508, -2701.8329177697501, -299.89511282443999, -73.716958721478775, -327.16392555236814,
      122.6820644458135, -482.269487341245, 184.16982328891754, -10.170002563794453,
    ])
  ),
  new ChebyshevCoefficients(
    2366820000 as Seconds,
    2524176000 as Seconds,
    new Float64Array([
      -12458981923.87141, 121861500.74753523, 2395812.9707422256, 36011.427566432954, 9702.3742060025525, -1721.6498523394266, -1616.9399709701538, -94.051182937622073,
      -607.06944014231362, -145.93741788864136, 954.36382312774651, 74.551636314392084,
    ]),
    new Float64Array([
      -9248672391.7323151, -196143051.63155428, 1812618.4969144184, -36257.456760247551, 8475.441705322266, 1575.8122502644856, -147.62137683232626, -615.18600880304973,
      171.31333328882852, -980.29550555547075, -113.79644009272258, 26.9441046555837,
    ]),
    new Float64Array([
      2564491982.0640664, -185777573.08735469, -596933.24583175185, -10367.833515222866, 3400.3676968892414, 756.18070569833117, -205.48383853435516, -275.65396827856699,
      70.044067819913224, -468.08909118175507, 99.156503486633298, -52.433241430918372,
    ])
  ),
];
